import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryInjName extends BaseWasmQuery {
    toPayload() {
        return toBase64({
            name: {
                address: this.params.address,
            },
        });
    }
}
